module.exports = __webpack_public_path__ + "img/StarRocks.8ed9b2ee.jpg";